import { HiDocumentSearch } from 'react-icons/hi'
import { FiUser, FiCalendar } from 'react-icons/fi'
import { ReactComponent as GeneratorIcon } from '../../../../shared/img/icon/generator.svg'

const formatDate = (value) => {
    if (!value) return ''
    const [year, month, day] = value.split('-')
    return day && month && year ? `${day}/${month}/${year}` : value
}

const getShortName = (fullName) => {
    if (!fullName) return ''
    const parts = fullName.trim().split(/\s+/)
    return parts.length > 1 ? `${parts[0]} ${parts[parts.length - 1]}` : parts[0]
}

function ListServiceOrderReviewRow({ dataArray, onReview }) {
    return (
        <div>
            {dataArray && dataArray.map((item) => (
                <div key={item._id} className="pg-item">
                    <div className="pg-item-main">
                        <div className="pg-item-header">
                            <span className="pg-item-name">{item.code || '—'}</span>
                            <span className="so-status-badge so-status-em_analise">Em análise</span>
                        </div>

                        <div className="so-item-desc">{item.name}</div>

                        <div className="so-item-meta">
                            <span className="so-item-meta-item">
                                <FiUser size={11} />
                                {item.client?.label || item.client?.name || '—'}
                            </span>
                            {item.generator?.label && (
                                <>
                                    <span className="so-item-meta-sep">·</span>
                                    <span className="so-item-meta-item">
                                        <GeneratorIcon className="so-item-meta-icon" />
                                        {item.generator.label}
                                    </span>
                                </>
                            )}
                            {item.scheduledDate && (
                                <>
                                    <span className="so-item-meta-sep">·</span>
                                    <span className="so-item-meta-item">
                                        <FiCalendar size={11} />
                                        Agendado: {formatDate(item.scheduledDate)} das {item.scheduledStartTime} às {item.scheduledEndTime}
                                    </span>
                                </>
                            )}
                            {item.technicians?.length > 0 && (
                                <>
                                    <span className="so-item-meta-sep">·</span>
                                    <span className="so-item-meta-item">
                                        {item.technicians.map((t) => getShortName(t.name || t.label)).join(', ')}
                                    </span>
                                </>
                            )}
                        </div>
                    </div>

                    <div className='shd-row-box-item-action'>
                        <HiDocumentSearch
                            className='so-icon-review'
                            title='Revisar'
                            onClick={() => onReview(item._id)}
                        />
                    </div>
                </div>
            ))}
        </div>
    )
}

export default ListServiceOrderReviewRow
